import { useIconField } from "@/hooks/useIconField";
import type { BetaModule } from "@/shared/config/betaModules";

type IconFieldProps = {
  modules: BetaModule[];
};

export function IconField({ modules }: IconFieldProps) {
  const containerRef = useIconField(modules);

  return (
    <div ref={containerRef} className="icon-field" aria-hidden="true" />
  );
}
